import * as React from 'react';

import { SVGProps } from './type';

const SvgComponent = (props: SVGProps) => {
  const { width = 16, height = 16, color = '#fff' } = props;

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 266.97 319.7"
      {...props}
      width={width}
      height={height}
    >
      <path
        className="cls-1"
        d="M16.23 78.86h235M80 72.6V44.4a29 29 0 0 1 7.86-19.94 26.23 26.23 0 0 1 19-8.26h53.71a26.19 26.19 0 0 1 19 8.26 28.92 28.92 0 0 1 7.87 19.94v28.2m40.28 6.26V270a29 29 0 0 1-7.86 19.94 26.23 26.23 0 0 1-19 8.26H66.59a26.23 26.23 0 0 1-19-8.26A28.92 28.92 0 0 1 39.73 270V78.86ZM102.4 141.53v78.33M165.06 141.53v78.33"
        style={{
          fill: 'none',
          stroke: color,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 31.33,
        }}
      />
    </svg>
  );
};

export default SvgComponent;
